import { defineCustomElement } from '@tyler-components-web/core';
import { OmnibarSearchComponent } from './omnibar-search';
export * from './omnibar-search-adapter';
export * from './omnibar-search-constants';
export * from './omnibar-search-foundation';
export * from './omnibar-search';
export function defineOmnibarSearchComponent() {
    defineCustomElement(OmnibarSearchComponent);
}
